var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g2, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginCarousel03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 222,
    viewBox: "0 0 225 222",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.935 150.474C192.526 202.854 133.371 225.353 87.0231 221.517C74.3682 220.469 48.9061 218.362 29.0251 199.561C-9.155 163.455 -3.27484 87.9844 33.2744 43.5513C37.9812 37.8292 70.5609 -0.50804 121.33 0.00510406C158.501 0.380807 184.591 21.378 187.763 23.9938C191.771 27.2984 200.61 35.151 208.576 47.6085C227.294 76.8796 228.939 117.742 214.935 150.474Z",
    fill: "#6476D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M207.919 113.507C208.44 113.071 210.416 109.757 213.578 113.506C213.92 113.684 214.804 113.184 214.692 112.834C210.992 107.437 206.384 112.502 206.836 113.058C207.287 113.613 207.313 114.014 207.919 113.507Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M216.924 111.259C217.614 111.178 218.263 110.707 218.069 110.104C217.878 109.509 211.292 101.815 203.957 110.488C203.867 110.595 203.823 110.733 203.835 110.871C203.847 111.01 203.914 111.139 204.021 111.228C204.355 111.506 204.64 111.693 205.009 111.647C211.721 104.036 216.234 111.34 216.924 111.259Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M220.352 108.961C220.842 109.059 221.844 108.69 221.586 107.885C209.993 95.2722 199.669 108.492 200.048 109.025C200.427 109.558 201.195 109.578 201.504 109.398C210.734 97.5593 219.862 108.862 220.352 108.961Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.511 97.6526C156.884 97.3292 155.236 98.0648 154.376 99.483C153.778 100.47 153.141 101.443 152.465 102.4C136.692 124.723 105.699 130.053 83.3757 114.28C79.1016 111.261 75.4529 107.681 72.4535 103.713L49.6924 113.375C54.8682 121.519 61.6631 128.638 69.8282 134.326C85.76 145.425 105.345 149.78 124.48 146.489C143.898 143.15 160.852 132.45 172.221 116.359C174.43 113.232 176.377 109.975 178.055 106.613C179.215 104.288 177.852 101.496 175.304 100.99C169.863 99.9087 164.175 98.7785 158.511 97.6526Z",
    fill: "#DFEBFD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.139 113.219L53.5745 125.628C49.5552 127.374 45.1034 124.28 45.339 119.904L47.2116 85.1351C47.4729 80.2844 53.1598 77.8137 56.8836 80.9332L83.5757 103.293C86.935 106.107 86.1583 111.472 82.139 113.219Z",
    fill: "#DFEBFD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8155 53.9364C68.4476 54.4918 70.2421 53.9123 71.2659 52.5252C77.0816 44.6457 85.2764 38.4059 95.2384 35.0429C110.984 29.7277 127.573 32.804 140.125 41.8523C146.439 36.0346 152.617 30.3423 158.187 25.21C153.35 21.2151 147.967 17.8049 142.111 15.0867C124.86 7.07862 105.091 6.0754 87.1046 12.2581C71.0037 17.7928 57.5923 28.4726 48.6634 42.7207C47.3151 44.8722 48.3558 47.7202 50.7646 48.5228C55.3478 50.0501 60.7123 51.8593 66.8155 53.9364Z",
    fill: "#DFEBFD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.432 36.13L154.217 16.0251C157.564 13.1962 162.718 14.8782 163.752 19.1368L171.964 52.9743C173.11 57.695 168.375 61.6977 163.911 59.7818L131.913 46.0493C127.886 44.321 127.086 38.959 130.432 36.13Z",
    fill: "#DFEBFD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M127.215 120.364C127.16 119.68 126.462 119.088 125.279 118.614C126.564 117.905 127.275 117.145 127.215 116.4C127.033 114.146 119.894 112.882 111.27 113.578C102.645 114.273 95.8003 116.664 95.9821 118.919C96.0373 119.602 96.7357 120.194 97.9184 120.669C96.6331 121.378 95.9221 122.137 95.9821 122.882C96.0373 123.566 96.7357 124.158 97.9184 124.632C96.6331 125.341 95.9221 126.101 95.9821 126.846C96.0373 127.529 96.7357 128.121 97.9184 128.596C96.6331 129.304 95.9221 130.064 95.9821 130.809C96.0626 131.806 97.5055 132.609 99.8342 133.134C99.804 133.871 99.8209 134.679 99.8933 135.57C100.231 139.724 104.903 142.981 111.083 142.981C117.263 142.981 122.612 138.54 122.673 134.373C122.688 133.352 122.644 132.453 122.552 131.654C125.509 130.667 127.31 129.46 127.215 128.291C127.16 127.607 126.462 127.015 125.279 126.541C126.564 125.832 127.275 125.072 127.215 124.327C127.16 123.643 126.462 123.052 125.279 122.577C126.564 121.868 127.275 121.109 127.215 120.364Z",
    fill: "url(#paint0_linear_7062_8778)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M107.279 134.031C104.717 134.031 102.373 133.842 100.437 133.471C100.324 133.45 100.251 133.342 100.272 133.229C100.294 133.117 100.402 133.043 100.515 133.065C103.545 133.645 107.592 133.773 111.911 133.424C115.445 133.139 118.75 132.569 121.468 131.776C121.578 131.744 121.693 131.807 121.725 131.917C121.757 132.027 121.694 132.142 121.585 132.174C118.839 132.975 115.506 133.55 111.944 133.837C110.34 133.967 108.772 134.031 107.279 134.031Z",
    fill: "url(#paint1_linear_7062_8778)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.321 130.064C103.993 130.064 101.019 129.75 98.921 129.153C98.8109 129.122 98.7472 129.007 98.7785 128.897C98.8099 128.787 98.924 128.723 99.0346 128.755C102.024 129.606 106.837 129.87 111.91 129.461C116.929 129.056 121.609 128.038 124.43 126.737C124.534 126.689 124.657 126.734 124.705 126.838C124.753 126.942 124.707 127.065 124.604 127.113C121.741 128.433 117.008 129.466 111.944 129.874C110.363 130.001 108.807 130.064 107.321 130.064Z",
    fill: "url(#paint2_linear_7062_8778)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.279 126.104C103.686 126.104 100.541 125.736 98.4246 125.038C98.3158 125.002 98.2568 124.885 98.2927 124.777C98.3285 124.668 98.4452 124.609 98.5542 124.645C101.5 125.616 106.493 125.935 111.911 125.498C116.929 125.093 121.609 124.075 124.43 122.774C124.534 122.726 124.657 122.771 124.705 122.875C124.753 122.979 124.708 123.102 124.604 123.15C121.741 124.471 117.008 125.503 111.944 125.911C110.339 126.04 108.77 126.104 107.279 126.104Z",
    fill: "url(#paint3_linear_7062_8778)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M107.306 122.139C104.456 122.139 101.863 121.908 99.8479 121.46C99.7363 121.436 99.6657 121.325 99.6905 121.213C99.7153 121.101 99.8264 121.031 99.9377 121.056C102.969 121.729 107.332 121.904 111.91 121.535C116.884 121.134 121.54 120.126 124.366 118.84C124.47 118.792 124.593 118.839 124.641 118.943C124.688 119.047 124.642 119.17 124.538 119.217C121.671 120.522 116.962 121.543 111.944 121.948C110.358 122.076 108.797 122.139 107.306 122.139Z",
    fill: "url(#paint4_linear_7062_8778)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1933 100.357C89.1458 96.6466 87.3666 93.179 84.9702 90.159C79.8358 83.688 71.4595 70.5279 70.4285 52.5667C68.9289 26.4413 92.0991 13.3615 113.242 15.1371C134.385 16.9127 155.248 32.6555 152.965 56.9601C151.559 71.9147 143.189 83.258 136.957 89.7724C132.999 93.909 130.176 98.9758 128.648 104.493C126.778 111.246 122.327 119.661 111.748 120.174C98.0587 120.838 92.3731 108.078 90.1933 100.357Z",
    fill: "#F7B62D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M137.118 83.0381C137.033 83.0381 136.948 83.0119 136.875 82.9577C136.694 82.8233 136.656 82.5678 136.791 82.3868C138.062 80.6743 139.228 78.9033 140.256 77.1229C140.369 76.9276 140.618 76.8611 140.813 76.9737C141.009 77.0863 141.075 77.3359 140.963 77.531C139.919 79.3384 138.735 81.1357 137.446 82.8733C137.366 82.9811 137.242 83.0381 137.118 83.0381Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M143.204 72.5939C143.15 72.5939 143.095 72.5831 143.041 72.5601C142.835 72.4703 142.74 72.2301 142.83 72.0233C150.741 53.8049 143.902 38.4779 143.832 38.3252C143.738 38.1204 143.828 37.8783 144.033 37.7844C144.238 37.6902 144.48 37.7804 144.574 37.9852C144.647 38.1451 146.378 41.9723 147.136 48.1472C147.836 53.8389 147.786 62.6578 143.578 72.3484C143.512 72.502 143.361 72.5939 143.204 72.5939Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.965 31.3096H132.717C134.036 31.3096 134.897 32.6933 134.314 33.8762L123.513 55.8052C122.698 57.4599 123.902 59.3953 125.747 59.3953H131.594C133.28 59.3953 134.275 61.2877 133.318 62.6771L102.643 107.23C102.03 108.12 100.634 107.615 100.733 106.538L103.973 71.2644C104.062 70.2935 103.298 69.4558 102.322 69.4558H96.6465C94.5013 69.4558 92.9368 67.4253 93.4839 65.351L101.824 33.7298C102.2 32.3034 103.49 31.3096 104.965 31.3096Z",
    fill: "#FFD57B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M101.793 106.721C101.762 106.721 101.724 106.705 101.705 106.685C101.7 106.679 101.691 106.67 101.695 106.626L104.935 71.3522C105.002 70.6198 104.756 69.888 104.261 69.3447C103.765 68.8013 103.059 68.4896 102.323 68.4896H96.6472C95.9265 68.4896 95.2609 68.1623 94.8211 67.5913C94.3814 67.0205 94.2345 66.2934 94.4182 65.5967L102.758 33.9753C103.022 32.9739 103.93 32.2744 104.966 32.2744H132.718C133.126 32.2744 133.337 32.5432 133.409 32.6587C133.481 32.7742 133.629 33.0824 133.448 33.449L122.647 55.3778C122.116 56.4562 122.178 57.7094 122.813 58.7302C123.448 59.7509 124.545 60.3603 125.747 60.3603H131.594C132.021 60.3603 132.395 60.586 132.593 60.9639C132.792 61.3417 132.766 61.7773 132.524 62.1289L101.848 106.682C101.821 106.721 101.808 106.721 101.793 106.721Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.827 101.023C103.771 101.023 103.715 101.013 103.66 100.993C103.449 100.917 103.316 100.708 103.337 100.485L104.164 91.4849C104.183 91.2725 104.37 91.116 104.584 91.1357C104.796 91.1552 104.952 91.3432 104.933 91.5557L104.204 99.4897L118.049 79.3812C118.17 79.2054 118.411 79.161 118.587 79.2821C118.762 79.403 118.807 79.6436 118.686 79.8192L104.233 100.81C104.139 100.946 103.986 101.023 103.827 101.023Z",
    fill: "#91B3FA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6493 53.7214C99.6167 53.7214 99.5836 53.7173 99.5505 53.7086C99.3442 53.6542 99.2212 53.4429 99.2755 53.2366L104.251 34.3702C104.337 34.0464 104.63 33.8203 104.965 33.8203H109.97C110.183 33.8203 110.356 33.9933 110.356 34.2066C110.356 34.4199 110.183 34.5928 109.97 34.5928H104.991L100.022 53.4337C99.9768 53.6069 99.8204 53.7214 99.6493 53.7214Z",
    fill: "#91B3FA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9316 158.039L45.9361 109.787H48.8861V159.22L44.9316 158.039Z",
    fill: "#7D97F4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1654 159.29C50.1654 160.051 49.8047 160.65 49.3597 160.65H44.2325C43.7875 160.65 43.4268 160.051 43.4268 159.29C43.4268 158.529 43.7875 157.93 44.2325 157.93H49.3597C49.8047 157.93 50.1654 158.529 50.1654 159.29Z",
    fill: "url(#paint5_linear_7062_8778)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M62.03 85.5977C61.4644 82.8155 52.1434 98.9037 49.0481 102.861C45.9528 106.819 48.3674 108.062 48.3674 108.062L48.7725 108.445C48.7731 108.446 48.7737 108.446 48.7743 108.446C49.9964 108.685 51.2481 108.202 51.851 107.129C54.712 102.035 62.4917 87.8694 62.03 85.5977Z",
    fill: "#7D97F4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9482 134.358C64.6611 135.196 55.0114 119.302 53.0224 114.688C51.0333 110.075 48.8155 111.633 48.8155 111.633L48.3155 111.841C48.315 111.841 48.3146 111.842 48.3142 111.842C47.4401 112.709 47.3117 114.094 47.9645 115.138C51.0627 120.091 59.7333 133.674 61.9482 134.358Z",
    fill: "#7D97F4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6019 114.575C17.2183 113.032 35.5993 110.231 40.4139 108.795C45.2286 107.359 45.3227 110.06 45.3227 110.06L45.3504 110.576C45.3504 110.577 45.3504 110.578 45.3504 110.578C45.3504 111.805 44.4009 112.793 43.1816 112.962C37.395 113.765 21.5479 115.835 19.6019 114.575Z",
    fill: "#7D97F4"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2989 110.973C49.7364 112.468 48.0692 113.223 46.5751 112.66C45.081 112.098 44.3258 110.431 44.8883 108.936C45.4508 107.442 47.118 106.687 48.6121 107.25C50.1062 107.812 50.8614 109.479 50.2989 110.973Z",
    fill: "url(#paint6_linear_7062_8778)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6007 112.025C47.3566 112.025 47.1117 111.981 46.8764 111.893C45.8164 111.493 45.2787 110.306 45.6777 109.246C45.8711 108.733 46.2527 108.326 46.7524 108.099C47.2523 107.873 47.81 107.854 48.3235 108.048C49.3836 108.447 49.9212 109.634 49.5223 110.694C49.3289 111.208 48.9472 111.615 48.4476 111.841C48.1768 111.964 47.8892 112.025 47.6007 112.025ZM47.5991 108.187C47.3489 108.187 47.0992 108.241 46.8647 108.347C46.431 108.544 46.0997 108.897 45.9321 109.342C45.5859 110.262 46.0524 111.292 46.972 111.638C47.4172 111.806 47.9019 111.79 48.3352 111.594C48.7689 111.397 49.1001 111.044 49.2678 110.598C49.6138 109.679 49.1474 108.649 48.2278 108.303C48.0236 108.226 47.8111 108.187 47.5991 108.187Z",
    fill: "url(#paint7_linear_7062_8778)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7148 191.389L22.7228 150.042H24.9514V192.447L21.7148 191.389Z",
    fill: "#7D97F4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.343 192.473C26.343 193.124 26.0342 193.561 25.6534 193.561H21.2648C20.8839 193.561 20.5752 193.124 20.5752 192.473C20.5752 191.821 20.8839 191.385 21.2648 191.385H25.6534C26.0342 191.385 26.343 191.821 26.343 192.473Z",
    fill: "url(#paint8_linear_7062_8778)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.498 129.43C36.0138 127.049 28.0356 140.819 25.3863 144.207C22.7369 147.594 24.8037 148.658 24.8037 148.658L25.1505 148.987C25.1509 148.987 25.1515 148.987 25.152 148.987C26.1981 149.192 27.2695 148.778 27.7854 147.859C30.2343 143.5 36.8932 131.375 36.498 129.43Z",
    fill: "#7D97F4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4272 171.166C38.7493 171.883 30.4898 158.279 28.7873 154.33C27.0847 150.381 25.1864 151.715 25.1864 151.715L24.7584 151.892C24.758 151.893 24.7576 151.893 24.7572 151.894C24.0091 152.636 23.8991 153.821 24.4579 154.715C27.1099 158.954 34.5314 170.58 36.4272 171.166Z",
    fill: "#7D97F4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0.181642 154.234C-1.85857 152.913 13.8745 150.515 17.9955 149.286C22.1166 148.057 22.2022 150.369 22.2022 150.369L22.2309 150.811C22.2309 150.811 22.2309 150.812 22.2309 150.812C22.2309 151.862 21.4132 152.708 20.3695 152.853C15.4165 153.54 1.84734 155.312 0.181642 154.234Z",
    fill: "#7D97F4"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4565 151.151C25.975 152.429 24.548 153.076 23.2691 152.594C21.9903 152.113 21.3439 150.686 21.8253 149.407C22.3068 148.128 23.7338 147.482 25.0127 147.963C26.2915 148.445 26.9379 149.872 26.4565 151.151Z",
    fill: "url(#paint9_linear_7062_8778)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1449 152.069C23.9371 152.069 23.7263 152.033 23.5207 151.955C22.6032 151.61 22.1379 150.583 22.4832 149.665C22.8288 148.748 23.8564 148.282 24.7733 148.628C25.6908 148.973 26.1561 150.001 25.8106 150.918C25.5425 151.63 24.8639 152.069 24.1449 152.069ZM24.1486 148.786C23.5395 148.786 22.9647 149.158 22.7376 149.761C22.4452 150.538 22.8394 151.408 23.6163 151.701C24.3943 151.993 25.2634 151.599 25.5561 150.822C25.8486 150.045 25.4547 149.175 24.6777 148.882C24.5034 148.817 24.3244 148.786 24.1486 148.786Z",
    fill: "url(#paint10_linear_7062_8778)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M145.083 157.991C145.076 157.543 144.894 157.118 144.578 156.809C144.262 156.501 143.838 156.335 143.402 156.349L108.118 157.506C107.22 157.535 106.515 158.305 106.542 159.226L108.283 219.16C108.309 220.069 109.04 220.79 109.927 220.781L144.736 220.67C145.17 220.666 145.351 220.25 145.654 219.931C145.957 219.612 146.123 219.182 146.115 218.736L145.083 157.991Z",
    fill: "#91B3FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.583 163.27L112.528 161.771L124.005 161.244L124.057 162.747L112.583 163.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.738 167.472L112.683 165.975L124.149 165.458L124.2 166.958L112.738 167.472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.892 171.663L112.837 170.169L124.293 169.662L124.344 171.159L112.892 171.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.045 175.849L112.99 174.358L124.436 173.86L124.487 175.355L113.045 175.849Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.199 180.026L113.145 178.538L124.58 178.05L124.631 179.541L113.199 180.026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.506 188.357L113.451 186.874L124.866 186.405L124.917 187.891L113.506 188.357Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.962 200.796L113.908 199.322L125.292 198.881L125.343 200.359L113.962 200.796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.352 184.195L113.298 182.71L124.723 182.231L124.774 183.72L113.352 184.195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.658 192.511L113.604 191.031L125.008 190.571L125.059 192.055L113.658 192.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.81 196.657L113.756 195.18L125.15 194.729L125.201 196.21L113.81 196.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.115 204.927L114.061 203.456L125.434 203.024L125.485 204.499L114.115 204.927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.266 209.05L114.212 207.581L125.575 207.159L125.626 208.631L114.266 209.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.417 213.166L114.363 211.7L125.717 211.287L125.767 212.757L114.417 213.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.568 217.273L114.515 215.809L125.858 215.406L125.908 216.873L114.568 217.273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.552 162.587L127.502 161.083L139.045 160.554L139.091 162.061L127.552 162.587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.694 166.801L127.644 165.3L139.176 164.78L139.222 166.285L127.694 166.801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.834 171.006L127.784 169.508L139.306 168.998L139.352 170.5L127.834 171.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.974 175.204L127.924 173.709L139.435 173.208L139.481 174.707L127.974 175.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.114 179.394L128.064 177.901L139.565 177.41L139.611 178.906L128.114 179.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.393 187.75L128.344 186.263L139.824 185.791L139.87 187.281L128.393 187.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.81 200.226L128.761 198.747L140.209 198.304L140.255 199.786L128.81 200.226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.254 183.576L128.204 182.086L139.694 181.604L139.74 183.098L128.254 183.576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.533 191.916L128.483 190.432L139.953 189.97L139.999 191.457L128.533 191.916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.672 196.074L128.622 194.592L140.081 194.14L140.127 195.625L128.672 196.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.949 204.368L128.899 202.892L140.338 202.458L140.383 203.938L128.949 204.368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.087 208.504L129.038 207.031L140.466 206.606L140.512 208.083L129.087 208.504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.225 212.632L129.176 211.161L140.593 210.746L140.639 212.22L129.225 212.632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.362 216.752L129.313 215.284L140.721 214.878L140.766 216.349L129.362 216.752Z",
    fill: "white"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M218.698 142.355C218.688 141.819 218.251 141.389 217.716 141.389H185.247C184.704 141.389 184.128 141.833 184.128 142.375V218.152C184.128 218.557 184.357 218.945 184.644 219.231C184.931 219.517 185.354 219.677 185.759 219.676L218.583 219.587C218.992 219.586 219.391 219.421 219.677 219.129C219.963 218.837 220.123 218.441 220.116 218.033L218.698 142.355Z",
    fill: "#91B3FA"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M200.051 146.759L189.43 146.723L189.434 145.394L200.043 145.427L200.051 146.759Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M200.08 151.654L189.415 151.606L189.419 150.266L200.072 150.311L200.08 151.654Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M200.11 156.589L189.4 156.529L189.404 155.178L200.101 155.235L200.11 156.589Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M200.139 161.566L189.386 161.493L189.39 160.131L200.131 160.201L200.139 161.566Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M200.169 166.583L189.371 166.498L189.375 165.124L200.161 165.206L200.169 166.583Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M200.23 176.746L189.341 176.635L189.345 175.238L200.221 175.346L200.23 176.746Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M200.322 192.314L189.294 192.163L189.298 190.73L200.313 190.878L200.322 192.314Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M200.199 171.643L189.355 171.545L189.36 170.16L200.191 170.255L200.199 171.643Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M200.26 181.891L189.325 181.767L189.329 180.358L200.252 180.479L200.26 181.891Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M200.291 187.08L189.31 186.943L189.314 185.522L200.282 185.656L200.291 187.08Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M200.353 197.591L189.278 197.426L189.283 195.981L200.345 196.143L200.353 197.591Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M200.385 202.914L189.263 202.735L189.267 201.278L200.376 201.454L200.385 202.914Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M200.417 208.284L189.247 208.091L189.251 206.621L200.409 206.811L200.417 208.284Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M200.449 213.699L189.23 213.491L189.235 212.009L200.44 212.213L200.449 213.699Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M213.976 146.808L203.288 146.771L203.276 145.438L213.952 145.471L213.976 146.808Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M214.063 151.718L203.331 151.669L203.319 150.325L214.039 150.371L214.063 151.718Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M214.151 156.669L203.374 156.608L203.362 155.253L214.127 155.311L214.151 156.669Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M214.239 161.662L203.417 161.588L203.405 160.222L214.215 160.292L214.239 161.662Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M214.327 166.696L203.46 166.61L203.448 165.232L214.303 165.315L214.327 166.696Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M214.508 176.892L203.549 176.78L203.537 175.379L214.483 175.487L214.508 176.892Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M214.784 192.512L203.684 192.36L203.672 190.923L214.759 191.071L214.784 192.512Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M214.417 171.773L203.504 171.674L203.492 170.284L214.392 170.38L214.417 171.773Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M214.599 182.055L203.593 181.93L203.581 180.517L214.574 180.638L214.599 182.055Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M214.691 187.261L203.638 187.122L203.626 185.697L214.666 185.832L214.691 187.261Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M214.877 197.808L203.729 197.642L203.717 196.192L214.851 196.355L214.877 197.808Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M214.971 203.149L203.775 202.969L203.763 201.507L214.945 201.683L214.971 203.149Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M215.066 208.538L203.822 208.343L203.81 206.868L215.04 207.059L215.066 208.538Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M215.162 213.972L203.869 213.763L203.856 212.275L215.136 212.481L215.162 213.972Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M183.434 131.089C183.426 130.536 183.196 130.011 182.795 129.631C182.394 129.252 181.857 129.05 181.305 129.072L139.385 130.753C138.666 130.782 138.102 131.382 138.12 132.102L140.184 219.031C140.219 220.519 141.445 221.702 142.934 221.684L182.634 221.2C183.178 221.193 183.696 220.971 184.075 220.582C184.455 220.192 184.663 219.668 184.656 219.125L183.434 131.089Z",
    fill: "#7D97F4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.557 145.09L143.363 145.106L143.055 136.17H149.289L149.557 145.09Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.209 145.067L153.317 145.081L153.072 136.17H159.002L159.209 145.067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.076 145.042L162.949 145.058L162.766 136.17H168.932L169.076 145.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.889 145.018L172.795 145.033L172.675 136.17H178.807L178.889 145.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.994 159.62L143.864 159.66L143.562 150.908L149.731 150.883L149.994 159.62Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.546 159.558L153.715 159.596L153.476 150.868L159.344 150.844L159.546 159.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.31 159.496L163.247 159.535L163.067 150.83L169.169 150.805L169.31 159.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.022 159.432L172.991 159.471L172.873 150.789L178.942 150.765L179.022 159.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.422 173.856L144.356 173.92L144.061 165.346L150.165 165.297L150.422 173.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.876 173.757L154.105 173.817L153.87 165.267L159.678 165.22L159.876 173.757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.541 173.656L163.539 173.719L163.363 165.19L169.402 165.142L169.541 173.656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.154 173.555L173.184 173.617L173.068 165.111L179.075 165.062L179.154 173.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.842 187.802L144.839 187.888L144.549 179.487L150.59 179.415L150.842 187.802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.199 187.667L154.487 187.749L154.257 179.371L160.005 179.302L160.199 187.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.766 187.53L163.825 187.616L163.653 179.258L169.631 179.187L169.766 187.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.282 187.394L173.373 187.478L173.26 179.143L179.205 179.071L179.282 187.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.253 201.469L145.31 201.577L145.026 193.345L151.006 193.25L151.253 201.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.516 201.301L154.861 201.404L154.636 193.193L160.325 193.103L160.516 201.301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.986 201.129L164.105 201.236L163.937 193.045L169.854 192.951L169.986 201.129Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.408 200.959L173.557 201.065L173.446 192.895L179.332 192.802L179.408 200.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.657 214.866L145.773 214.995L145.495 206.926L151.414 206.81L151.657 214.866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.827 214.666L155.229 214.788L155.008 206.739L160.64 206.629L160.827 214.666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.204 214.462L164.381 214.589L164.216 206.559L170.074 206.444L170.204 214.462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.531 214.257L173.739 214.384L173.63 206.374L179.457 206.26L179.531 214.257Z",
    fill: "white"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M223.632 160.266C222.084 158.91 219.618 157.388 216.058 156.952L214.854 157.688C214.854 157.688 215.622 158.821 217.025 160.017C218.313 160.765 220.304 161.779 221.954 161.999C223.558 162.213 223.795 161.244 223.632 160.266Z",
    fill: "url(#paint11_linear_7062_8778)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M224.798 161.423C224.493 161.076 224.104 160.678 223.632 160.265C223.795 161.242 223.559 162.212 221.954 161.998C220.305 161.778 218.314 160.764 217.025 160.016C218.641 161.393 221.099 162.856 224.201 162.77C224.89 162.751 225.253 161.94 224.798 161.423Z",
    fill: "#7D97F4"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M207.636 138.216C207.636 138.216 205.886 138.308 205.672 141.909C205.672 141.909 209.73 145.547 215.212 146.413C215.623 146.478 214.636 143.603 214.488 143.214C213.782 141.361 211.559 140.168 207.636 138.216Z",
    fill: "url(#paint12_linear_7062_8778)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M214.488 143.215C213.535 143.523 213.115 144.874 210.696 143.981C208.355 143.117 206.615 142.002 205.72 141.359C205.7 141.534 205.684 141.715 205.672 141.909C205.672 141.909 209.951 145.979 215.432 146.845C215.844 146.91 216.17 146.499 216.022 146.11C215.756 145.411 215.276 144.352 214.488 143.215Z",
    fill: "#7D97F4"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M187.928 133.983H191.621C191.621 133.983 202.956 121.464 210.39 120.201C210.39 120.201 215.565 126.807 210.114 139.15C209.676 140.143 208.45 140.584 207.535 140C207.261 139.825 207.065 139.591 206.945 139.297L207.384 128.758C207.384 128.758 197.715 137.215 196.034 138.847C194.354 140.479 185.811 139.484 187.928 133.983Z",
    fill: "url(#paint13_linear_7062_8778)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M216.987 157.473C215.195 145.013 205.319 136.842 205.319 136.842L188.025 136.654L185.698 137.595L184.926 136.973L180.596 139.659C180.596 139.659 186.188 145.727 192.204 142.836C194.585 142.143 201.7 140.783 205.634 147.751C209.528 154.646 215.499 158.546 215.499 158.546C217.284 158.389 216.987 157.473 216.987 157.473Z",
    fill: "url(#paint14_linear_7062_8778)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M188.472 122.723C188.472 122.723 190.333 132.053 199.455 135.744L202.7 135.362L203.466 136.582L195.855 136.825C195.855 136.825 189.349 134.248 185.901 127.226C185.788 126.994 183.889 123.075 188.472 122.723Z",
    fill: "url(#paint15_linear_7062_8778)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M189.469 136.502C189.469 136.502 187.352 130.747 186.897 125.155C186.897 125.155 188.446 123.824 189.414 123.25C189.727 123.064 189.845 122.671 189.687 122.342C188.975 120.868 184.671 115.078 184.349 114.998C182.596 114.561 175.409 111.143 170.347 118.067C168.174 121.039 170.622 130.46 180.478 139.933L181.675 140.855L189.469 136.502Z",
    fill: "url(#paint16_linear_7062_8778)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M181.311 126.416C181.311 126.416 187.193 133.381 194.714 134.399C194.714 134.399 196.657 132.627 198.102 133.26C199.547 133.892 201.529 136.684 201.529 136.684H191.873C191.873 136.684 182.743 136.363 178.181 130.826C178.548 128.889 179.647 127.732 181.311 126.416Z",
    fill: "url(#paint17_linear_7062_8778)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M177.88 110.113L176.592 114.406C176.533 114.603 176.606 114.815 176.776 114.931C177.395 115.356 179.015 116.2 181.237 115.38C181.491 115.286 181.665 115.049 181.687 114.779L181.992 111.039L177.88 110.113Z",
    fill: "url(#paint18_linear_7062_8778)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M201.043 137.225L205.378 122.766C205.555 122.176 206.079 121.758 206.694 121.716L212.547 121.316C213.142 121.275 213.585 121.856 213.387 122.419L208.54 136.226C208.384 136.671 207.985 136.986 207.516 137.033L201.752 137.673L201.043 137.225Z",
    fill: "url(#paint19_linear_7062_8778)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M201.752 137.673C201.743 137.673 201.733 137.673 201.724 137.673L189.442 137.052C189.138 137.037 188.904 136.778 188.92 136.474C188.935 136.171 189.195 135.932 189.497 135.952L201.779 136.573C202.083 136.588 202.317 136.847 202.301 137.151C202.286 137.445 202.043 137.673 201.752 137.673Z",
    fill: "url(#paint20_linear_7062_8778)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M186.897 125.266H186.897C186.836 125.266 186.787 125.216 186.787 125.156C186.795 122.591 185.805 119.187 185.795 119.153C185.778 119.094 185.812 119.033 185.87 119.016C185.929 118.999 185.99 119.033 186.007 119.091C186.017 119.125 187.016 122.56 187.007 125.156C187.007 125.217 186.958 125.266 186.897 125.266Z",
    fill: "url(#paint21_linear_7062_8778)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M181.311 126.526C181.278 126.526 181.246 126.512 181.224 126.484C181.197 126.45 178.51 123.034 177.586 120.692C177.564 120.635 177.591 120.571 177.648 120.549C177.704 120.526 177.768 120.554 177.791 120.611C178.703 122.923 181.37 126.314 181.397 126.348C181.435 126.396 181.427 126.465 181.379 126.503C181.359 126.519 181.335 126.526 181.311 126.526Z",
    fill: "url(#paint22_linear_7062_8778)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M177.536 131.75L177.454 131.715C173.563 130.049 171.161 125.405 171.137 125.359C171.109 125.304 171.131 125.238 171.185 125.211C171.239 125.182 171.306 125.205 171.333 125.258C171.357 125.304 173.69 129.814 177.459 131.477L177.853 130.92C177.889 130.87 177.957 130.858 178.007 130.893C178.057 130.928 178.068 130.997 178.033 131.047L177.536 131.75Z",
    fill: "url(#paint23_linear_7062_8778)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M186.141 103.906C186.141 103.906 185.698 108.658 184.702 110.731C183.705 112.805 183.42 114.349 180.87 113.473C178.321 112.596 176.999 110.358 177.042 107.769C177.042 107.769 177.08 103.764 178.15 102.705C179.22 101.646 186.141 103.906 186.141 103.906Z",
    fill: "url(#paint24_linear_7062_8778)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M178.631 106.766L178.796 106.781C179.005 106.799 179.188 106.638 179.193 106.428C179.214 105.614 179.375 103.809 180.388 103.925C181.693 104.075 186.384 105.539 188.119 104.544C189.785 103.587 190.033 101.304 189.16 100.134C189.101 100.056 188.994 100.034 188.912 100.087L188.714 100.217C188.578 100.306 188.403 100.185 188.439 100.027C188.473 99.8747 188.313 99.7532 188.177 99.8291C187.651 100.123 186.496 100.432 184.271 99.6925C181.109 98.641 178.572 98.757 177.432 100.714C177.36 100.838 177.187 100.835 177.116 100.71C176.975 100.464 176.669 100.216 176.006 100.348C174.853 100.576 174.228 102.473 175.177 104.839C175.222 104.951 175.151 105.079 175.03 105.088C174.604 105.119 173.87 105.347 174.724 106.661C175.606 108.019 176.571 108.479 176.964 108.618C177.061 108.652 177.167 108.597 177.196 108.498L177.772 106.544C177.805 106.433 177.931 106.381 178.033 106.437L178.631 106.766Z",
    fill: "url(#paint25_linear_7062_8778)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M178.501 107.173C178.501 107.173 179.213 104.374 177.737 104.456C176.261 104.537 176.795 107.513 177.627 108.091L178.501 107.173Z",
    fill: "url(#paint26_linear_7062_8778)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8975 219.918H74.8366L72.5336 162.92H65.9125L63.8975 219.918Z",
    fill: "url(#paint27_linear_7062_8778)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5947 220.815C61.5947 220.896 61.694 220.963 61.7903 220.964L76.4498 221.07C76.7773 221.072 77.1398 220.811 77.1398 220.487V219.761C77.1398 219.601 76.9857 219.445 76.8693 219.331C76.7525 219.217 76.5505 219.154 76.3882 219.156L61.8042 219.405C61.7112 219.406 61.5948 219.47 61.5948 219.549L61.5947 220.815Z",
    fill: "url(#paint28_linear_7062_8778)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5496 143.471L92.1065 144.159C92.4146 144.163 92.782 144.398 92.9271 144.685L108.076 174.559C108.223 174.85 108.093 175.087 107.786 175.089L52.31 175.421C51.9815 175.423 51.5951 175.181 51.4469 174.881L36.2183 143.999C36.0722 143.703 36.2207 143.467 36.5496 143.471Z",
    fill: "url(#paint29_linear_7062_8778)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0597 175.072L35.8312 144.19C35.6935 143.911 35.6971 143.62 35.8412 143.392C35.985 143.163 36.2522 143.043 36.5551 143.039L92.1122 143.728C92.5793 143.733 93.0953 144.061 93.3125 144.489L108.461 174.364C108.603 174.645 108.604 174.938 108.464 175.168C108.328 175.39 108.082 175.519 107.788 175.521L52.3126 175.853C52.3105 175.853 52.3084 175.853 52.3062 175.853C51.8147 175.853 51.2799 175.518 51.0597 175.072ZM92.5422 144.88C92.4707 144.739 92.248 144.593 92.1015 144.591L36.6532 143.904L51.8343 174.69C51.9092 174.842 52.1422 174.99 52.3059 174.99H52.3076L107.641 174.657L92.5422 144.88Z",
    fill: "url(#paint30_linear_7062_8778)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2535 146.047L91.3706 146.216C91.6792 146.219 92.0473 146.455 92.1927 146.742L95.6729 153.611C95.8189 153.899 95.6871 154.131 95.3785 154.129L80.2676 154.031C79.9533 154.028 79.58 153.791 79.4339 153.5L75.948 146.565C75.8022 146.275 75.9392 146.043 76.2535 146.047Z",
    fill: "url(#paint31_linear_7062_8778)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M58.078 145.843L73.518 146.015C73.8333 146.019 74.2068 146.257 74.3524 146.547L77.8389 153.489C77.9851 153.78 77.8481 154.014 77.533 154.012L62.0985 153.911C61.7775 153.909 61.3985 153.669 61.2521 153.376L57.7604 146.366C57.6146 146.074 57.7568 145.839 58.078 145.843Z",
    fill: "url(#paint32_linear_7062_8778)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5091 145.636L55.2827 145.812C55.6048 145.816 55.984 146.056 56.1299 146.349L59.6221 153.365C59.7684 153.659 59.6262 153.896 59.3043 153.894L43.5357 153.791C43.2078 153.789 42.8229 153.546 42.6764 153.249L39.1794 146.165C39.0333 145.869 39.181 145.632 39.5091 145.636Z",
    fill: "url(#paint33_linear_7062_8778)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0095 155.504L96.1193 155.589C96.4278 155.591 96.7962 155.826 96.9422 156.114L100.439 163.015C100.585 163.305 100.454 163.539 100.146 163.539L85.0422 163.525C84.7281 163.525 84.3543 163.288 84.2076 162.996L80.7053 156.028C80.5589 155.737 80.6952 155.502 81.0095 155.504Z",
    fill: "url(#paint34_linear_7062_8778)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8407 155.401L78.2741 155.488C78.5892 155.49 78.9632 155.728 79.1095 156.019L82.6123 162.993C82.7592 163.286 82.6229 163.523 82.308 163.522L66.8803 163.508C66.5594 163.508 66.18 163.268 66.0329 162.973L62.5246 155.931C62.3781 155.636 62.5196 155.4 62.8407 155.401Z",
    fill: "url(#paint35_linear_7062_8778)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2796 155.297L60.0472 155.386C60.3692 155.387 60.7488 155.628 60.8954 155.922L64.4042 162.971C64.5512 163.267 64.4097 163.506 64.0879 163.506L48.3256 163.491C47.9977 163.491 47.6124 163.249 47.4651 162.951L43.9514 155.832C43.8047 155.535 43.9516 155.295 44.2796 155.297Z",
    fill: "url(#paint36_linear_7062_8778)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7868 165.006L100.889 165.006C101.197 165.006 101.566 165.241 101.713 165.531L105.226 172.464C105.373 172.755 105.243 172.992 104.934 172.993L89.8386 173.065C89.5246 173.066 89.1504 172.829 89.0029 172.536L85.4842 165.535C85.3371 165.243 85.4727 165.006 85.7868 165.006Z",
    fill: "url(#paint37_linear_7062_8778)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6268 165.005L83.0533 165.005C83.3683 165.005 83.7427 165.243 83.8897 165.535L87.4091 172.543C87.5566 172.836 87.421 173.076 87.1062 173.077L71.6856 173.15C71.3649 173.152 70.985 172.912 70.8372 172.616L67.3123 165.54C67.1651 165.244 67.3059 165.005 67.6268 165.005Z",
    fill: "url(#paint38_linear_7062_8778)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0726 165.005L64.834 165.005C65.1558 165.005 65.5359 165.245 65.6831 165.541L69.4762 173.161L53.138 173.239C52.8102 173.24 52.4244 172.998 52.2765 172.699L48.7459 165.546C48.5984 165.247 48.7448 165.005 49.0726 165.005Z",
    fill: "url(#paint39_linear_7062_8778)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6686 174.356C52.285 174.356 51.9249 173.981 51.7519 173.631L46.1381 162.253C46.1049 162.185 46.1325 162.104 46.1997 162.071C46.2671 162.038 46.3489 162.065 46.3819 162.132L51.9957 173.511C52.1333 173.789 52.4157 174.084 52.6685 174.084C52.6685 174.084 52.6695 174.084 52.6701 174.084L63.4127 174.027C63.4826 174.023 63.549 174.087 63.5496 174.163C63.5498 174.238 63.4892 174.299 63.4143 174.299L52.6717 174.356H52.6686V174.356Z",
    fill: "#91B3FA"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0365 154.898C96.9871 154.898 96.9392 154.87 96.9151 154.823L92.1173 145.357C92.0049 145.135 91.6413 145.011 91.3565 145.008L79.5426 144.867C79.4675 144.866 79.4074 144.804 79.4082 144.729C79.409 144.654 79.4698 144.595 79.5442 144.595H79.5458L91.3597 144.736C91.7222 144.74 92.1897 144.898 92.36 145.234L97.1578 154.7C97.1918 154.767 97.1649 154.849 97.0978 154.883C97.0782 154.893 97.0572 154.898 97.0365 154.898Z",
    fill: "#91B3FA"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0439 219.876H97.8038L95.9597 202.817H90.6576L89.0439 219.876Z",
    fill: "url(#paint40_linear_7062_8778)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2002 220.594C87.2002 220.659 87.2797 220.713 87.3567 220.713L99.0958 220.798C99.3581 220.8 99.6484 220.591 99.6484 220.331V219.75C99.6484 219.622 99.525 219.497 99.4318 219.406C99.3383 219.314 99.1765 219.264 99.0465 219.266L87.3679 219.465C87.2934 219.466 87.2002 219.517 87.2002 219.58V220.594Z",
    fill: "url(#paint41_linear_7062_8778)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1443 185.064L111.633 185.616C111.88 185.619 112.174 185.807 112.291 186.037L124.421 209.96C124.539 210.192 124.435 210.382 124.189 210.384L79.765 210.65C79.502 210.652 79.1924 210.458 79.0738 210.217L66.879 185.488C66.762 185.251 66.8809 185.061 67.1443 185.064Z",
    fill: "url(#paint42_linear_7062_8778)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7637 210.37L66.569 185.641C66.4586 185.417 66.4616 185.184 66.577 185.001C66.6922 184.818 66.9061 184.722 67.1487 184.719L111.638 185.27C112.012 185.275 112.425 185.537 112.599 185.88L124.73 209.803C124.844 210.028 124.845 210.263 124.732 210.447C124.623 210.625 124.426 210.728 124.191 210.729L79.767 210.996C79.767 210.996 79.7637 210.996 79.762 210.996C79.3683 210.996 78.94 210.728 78.7637 210.37ZM111.982 186.193C111.925 186.08 111.747 185.963 111.629 185.962L67.2272 185.411L79.384 210.064C79.444 210.186 79.6306 210.304 79.7616 210.304H79.763L124.073 210.038L111.982 186.193Z",
    fill: "url(#paint43_linear_7062_8778)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9389 187.127L111.044 187.262C111.292 187.265 111.586 187.453 111.703 187.683L114.49 193.184C114.607 193.415 114.501 193.6 114.254 193.599L102.153 193.52C101.902 193.518 101.603 193.328 101.486 193.096L98.6941 187.542C98.5774 187.31 98.6871 187.124 98.9389 187.127Z",
    fill: "url(#paint44_linear_7062_8778)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3841 186.965L96.7483 187.103C97.0008 187.106 97.2999 187.296 97.4165 187.529L100.208 193.088C100.326 193.32 100.216 193.508 99.9635 193.506L87.6037 193.426C87.3467 193.424 87.0432 193.232 86.926 192.997L84.1298 187.384C84.0131 187.15 84.127 186.962 84.3841 186.965Z",
    fill: "url(#paint45_linear_7062_8778)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5142 186.798L82.1455 186.939C82.4034 186.942 82.7071 187.134 82.8239 187.369L85.6204 192.987C85.7377 193.223 85.6238 193.412 85.3659 193.411L72.7387 193.329C72.476 193.327 72.1679 193.133 72.0506 192.895L69.2502 187.222C69.1332 186.985 69.2515 186.795 69.5142 186.798Z",
    fill: "url(#paint46_linear_7062_8778)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M102.747 194.7L114.846 194.768C115.093 194.77 115.388 194.958 115.505 195.189L118.305 200.715C118.423 200.947 118.318 201.134 118.071 201.134L105.976 201.123C105.724 201.123 105.425 200.933 105.308 200.699L102.503 195.12C102.386 194.887 102.495 194.699 102.747 194.7Z",
    fill: "url(#paint47_linear_7062_8778)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1978 194.619L100.557 194.689C100.809 194.69 101.108 194.88 101.226 195.114L104.031 200.699C104.148 200.933 104.039 201.122 103.787 201.122L91.4328 201.111C91.1758 201.111 90.8719 200.919 90.7542 200.683L87.9448 195.043C87.8274 194.807 87.9407 194.618 88.1978 194.619Z",
    fill: "url(#paint48_linear_7062_8778)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3348 194.535L85.9613 194.606C86.2191 194.608 86.5231 194.8 86.6404 195.036L89.4502 200.681C89.568 200.917 89.4547 201.109 89.197 201.109L76.5747 201.097C76.3121 201.097 76.0036 200.903 75.8857 200.664L73.0719 194.964C72.9544 194.725 73.0722 194.534 73.3348 194.535Z",
    fill: "url(#paint49_linear_7062_8778)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M106.572 202.31L118.666 202.31C118.913 202.31 119.208 202.498 119.326 202.73L122.139 208.282C122.257 208.515 122.152 208.705 121.905 208.706L109.817 208.763C109.565 208.764 109.266 208.575 109.147 208.34L106.33 202.733C106.212 202.499 106.321 202.31 106.572 202.31Z",
    fill: "url(#paint50_linear_7062_8778)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M92.03 202.309L104.383 202.309C104.636 202.309 104.935 202.499 105.053 202.733L107.871 208.345C107.99 208.58 107.881 208.772 107.629 208.773L95.2803 208.831C95.0235 208.833 94.7193 208.641 94.601 208.403L91.7782 202.737C91.6603 202.5 91.7731 202.309 92.03 202.309Z",
    fill: "url(#paint51_linear_7062_8778)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1728 202.309L89.7943 202.309C90.052 202.309 90.3564 202.501 90.4743 202.738L93.5118 208.84L80.4284 208.902C80.1659 208.903 79.857 208.71 79.7386 208.47L76.9113 202.742C76.7931 202.502 76.9103 202.309 77.1728 202.309Z",
    fill: "url(#paint52_linear_7062_8778)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0519 209.824C79.7332 209.824 79.4354 209.516 79.2935 209.228L74.7982 200.117C74.765 200.05 74.7927 199.968 74.8598 199.935C74.9275 199.902 75.0088 199.929 75.0421 199.997L79.5373 209.108C79.6454 209.327 79.8672 209.552 80.0518 209.552H80.0529L88.6554 209.507C88.7391 209.504 88.7914 209.567 88.7922 209.642C88.7925 209.717 88.7319 209.778 88.657 209.779L80.0544 209.824H80.0519Z",
    fill: "#91B3FA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M115.581 194.243C115.532 194.243 115.484 194.216 115.46 194.168L111.618 186.588C111.536 186.426 111.256 186.326 111.032 186.324L101.572 186.21C101.497 186.209 101.437 186.148 101.438 186.073C101.438 185.997 101.506 185.929 101.575 185.938L111.036 186.051C111.334 186.055 111.719 186.186 111.86 186.465L115.703 194.045C115.737 194.112 115.71 194.194 115.643 194.228C115.623 194.238 115.602 194.243 115.581 194.243Z",
    fill: "#91B3FA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6045 219.719H41.8576L39.6991 199.753H33.4932L31.6045 219.719Z",
    fill: "url(#paint53_linear_7062_8778)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4463 220.559C29.4463 220.636 29.5393 220.699 29.6296 220.699L43.3697 220.799C43.6767 220.801 44.0165 220.556 44.0165 220.252V219.572C44.0165 219.421 43.8721 219.276 43.763 219.169C43.6535 219.062 43.4641 219.002 43.312 219.005L29.6426 219.238C29.5554 219.239 29.4463 219.299 29.4463 219.373V220.559Z",
    fill: "url(#paint54_linear_7062_8778)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M5.97259 178.974L58.0454 179.619C58.3341 179.623 58.6785 179.843 58.8145 180.112L73.013 208.113C73.1511 208.385 73.0295 208.607 72.7412 208.609L20.7445 208.921C20.4366 208.923 20.0744 208.696 19.9355 208.414L5.66196 179.469C5.52523 179.192 5.66434 178.97 5.97259 178.974Z",
    fill: "url(#paint55_linear_7062_8778)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M19.572 208.593L5.29855 179.648C5.16943 179.387 5.17284 179.114 5.3079 178.9C5.44265 178.686 5.69312 178.573 5.97704 178.569L58.05 179.215C58.4878 179.22 58.9714 179.527 59.175 179.929L73.3735 207.93C73.5068 208.193 73.5078 208.467 73.3761 208.683C73.2488 208.892 73.0181 209.012 72.743 209.014L20.7462 209.326C20.7442 209.326 20.7423 209.326 20.7423 209.326C20.2797 209.326 19.7783 209.012 19.572 208.593ZM58.453 180.295C58.3859 180.162 58.1772 180.026 58.0399 180.024L6.0689 179.38L20.298 208.235C20.3682 208.378 20.5867 208.516 20.74 208.516H20.7416L72.6051 208.204L58.453 180.295Z",
    fill: "url(#paint56_linear_7062_8778)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1868 181.387L57.3558 181.545C57.6451 181.548 57.99 181.769 58.1263 182.038L61.3883 188.476C61.525 188.746 61.4014 188.964 61.1123 188.962L46.949 188.87C46.6545 188.868 46.3046 188.645 46.1676 188.373L42.9002 181.872C42.7638 181.601 42.8922 181.384 43.1868 181.387Z",
    fill: "url(#paint57_linear_7062_8778)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1511 181.196L40.6229 181.358C40.9184 181.361 41.2685 181.584 41.405 181.856L44.6729 188.363C44.8099 188.635 44.6815 188.855 44.3861 188.853L29.9196 188.759C29.6187 188.757 29.2635 188.532 29.1263 188.257L25.8536 181.687C25.7168 181.413 25.8501 181.193 26.1511 181.196Z",
    fill: "url(#paint58_linear_7062_8778)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M8.74663 181.002L23.531 181.167C23.8329 181.171 24.1884 181.396 24.325 181.67L27.5982 188.246C27.7354 188.522 27.6021 188.744 27.3003 188.742L12.5207 188.646C12.2132 188.644 11.8526 188.417 11.7152 188.138L8.43758 181.498C8.30069 181.221 8.43909 180.999 8.74663 181.002Z",
    fill: "url(#paint59_linear_7062_8778)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6439 190.251L61.8062 190.331C62.0954 190.332 62.4406 190.553 62.5775 190.823L65.8547 197.291C65.9921 197.562 65.8692 197.782 65.5801 197.782L51.4238 197.769C51.1294 197.769 50.7791 197.547 50.6415 197.273L47.3588 190.742C47.2216 190.469 47.3493 190.249 47.6439 190.251Z",
    fill: "url(#paint60_linear_7062_8778)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6151 190.155L45.0806 190.237C45.3759 190.238 45.7265 190.461 45.8636 190.734L49.1468 197.271C49.2844 197.545 49.1567 197.767 48.8615 197.767L34.4013 197.754C34.1005 197.753 33.745 197.529 33.6071 197.252L30.3188 190.651C30.1816 190.376 30.3142 190.154 30.6151 190.155Z",
    fill: "url(#paint61_linear_7062_8778)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2174 190.058L27.9961 190.141C28.2979 190.143 28.6537 190.368 28.7911 190.644L32.0799 197.251C32.2177 197.528 32.0851 197.752 31.7835 197.752L17.0096 197.738C16.7023 197.738 16.3412 197.511 16.2031 197.231L12.9097 190.559C12.7722 190.28 12.91 190.056 13.2174 190.058Z",
    fill: "url(#paint62_linear_7062_8778)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1216 199.157L66.2768 199.158C66.5658 199.158 66.9115 199.378 67.049 199.649L70.3414 206.148C70.4794 206.42 70.3572 206.642 70.0683 206.644L55.9192 206.711C55.6249 206.712 55.2742 206.49 55.136 206.215L51.8379 199.653C51.7 199.379 51.8271 199.157 52.1216 199.157Z",
    fill: "url(#paint63_linear_7062_8778)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1005 199.156L49.5596 199.157C49.8548 199.157 50.2057 199.379 50.3436 199.653L53.6422 206.221C53.7805 206.497 53.6534 206.721 53.3583 206.722L38.9048 206.791C38.6042 206.792 38.2481 206.568 38.1096 206.29L34.8057 199.658C34.6677 199.381 34.7997 199.156 35.1005 199.156Z",
    fill: "url(#paint64_linear_7062_8778)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7097 199.156L32.4826 199.157C32.7842 199.157 33.1404 199.382 33.2784 199.659L36.8337 206.801L21.52 206.874C21.2128 206.875 20.8512 206.649 20.7126 206.368L17.4034 199.663C17.2652 199.383 17.4024 199.156 17.7097 199.156Z",
    fill: "url(#paint65_linear_7062_8778)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0802 207.93C20.7169 207.93 20.3764 207.576 20.2132 207.245L14.9516 196.581C14.9183 196.514 14.946 196.432 15.0131 196.399C15.0809 196.366 15.1622 196.393 15.1954 196.461L20.457 207.125C20.585 207.385 20.8514 207.661 21.0815 207.658L31.1502 207.605H31.151C31.2259 207.605 31.2868 207.665 31.287 207.74C31.2873 207.815 31.2267 207.876 31.1518 207.877L21.0831 207.93C21.082 207.93 21.081 207.93 21.0802 207.93Z",
    fill: "#91B3FA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6651 189.692C62.6158 189.692 62.568 189.665 62.5438 189.617L58.0468 180.745C57.943 180.54 57.6057 180.426 57.3413 180.423L46.2682 180.29C46.1931 180.289 46.133 180.228 46.1338 180.153C46.1344 180.077 46.189 180.011 46.2714 180.018L57.3445 180.151C57.6866 180.155 58.1283 180.304 58.2895 180.622L62.7864 189.494C62.8204 189.561 62.7936 189.643 62.7264 189.677C62.7068 189.687 62.6858 189.692 62.6651 189.692Z",
    fill: "#91B3FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7062_8778",
    x1: 112.576,
    y1: 117.156,
    x2: 106.231,
    y2: 159.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7062_8778",
    x1: 110.07,
    y1: 136.012,
    x2: 96.5373,
    y2: 185.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7062_8778",
    x1: 109.569,
    y1: 135.874,
    x2: 96.0359,
    y2: 185.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7062_8778",
    x1: 108.311,
    y1: 135.529,
    x2: 94.7782,
    y2: 184.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7062_8778",
    x1: 107.974,
    y1: 135.437,
    x2: 94.4408,
    y2: 184.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7062_8778",
    x1: 44.8274,
    y1: 124.416,
    x2: 47.6413,
    y2: 174.263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7062_8778",
    x1: 45.1459,
    y1: 108.416,
    x2: 50.0413,
    y2: 111.494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7062_8778",
    x1: 45.8604,
    y1: 108.877,
    x2: 49.3394,
    y2: 111.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7062_8778",
    x1: 24.3796,
    y1: 171.854,
    x2: 21.9531,
    y2: 226.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7062_8778",
    x1: 22.0458,
    y1: 148.962,
    x2: 26.236,
    y2: 151.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7062_8778",
    x1: 22.6418,
    y1: 149.345,
    x2: 25.652,
    y2: 151.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7062_8778",
    x1: 217.821,
    y1: 158.271,
    x2: 229.822,
    y2: 167.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7062_8778",
    x1: 209.405,
    y1: 141.638,
    x2: 215.749,
    y2: 148.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7062_8778",
    x1: 228.949,
    y1: 85.3099,
    x2: 182.033,
    y2: 165.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7062_8778",
    x1: 213.332,
    y1: 126.482,
    x2: 191.731,
    y2: 159.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7062_8778",
    x1: 198.434,
    y1: 125.718,
    x2: 190.286,
    y2: 135.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7062_8778",
    x1: 192.739,
    y1: 146.802,
    x2: 179.683,
    y2: 123.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF928E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7062"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7062_8778",
    x1: 188.934,
    y1: 134.534,
    x2: 205.218,
    y2: 112.255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7062_8778",
    x1: 178.971,
    y1: 116.072,
    x2: 179.571,
    y2: 110.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7062_8778",
    x1: 201.043,
    y1: 129.493,
    x2: 213.435,
    y2: 129.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7062_8778",
    x1: 202.547,
    y1: 134.91,
    x2: 192.639,
    y2: 137.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7062_8778",
    x1: 186.397,
    y1: 122.143,
    x2: 182.507,
    y2: 129.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7062_8778",
    x1: 179.711,
    y1: 133.374,
    x2: 179.491,
    y2: 123.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7062_8778",
    x1: 174.704,
    y1: 133.481,
    x2: 174.484,
    y2: 123.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1473D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9605A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7062_8778",
    x1: 184.632,
    y1: 107.472,
    x2: 171.072,
    y2: 109.515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7062_8778",
    x1: 181.102,
    y1: 97.9938,
    x2: 183.683,
    y2: 114.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7062_8778",
    x1: 184.301,
    y1: 105.274,
    x2: 170.741,
    y2: 107.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEBBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF928E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_7062_8778",
    x1: 86.0977,
    y1: 151.197,
    x2: 78.3006,
    y2: 171.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_7062_8778",
    x1: -140.825,
    y1: -317.43,
    x2: -133.028,
    y2: -297.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_7062_8778",
    x1: 87.2585,
    y1: 158.216,
    x2: 20.2148,
    y2: 162.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_7062_8778",
    x1: 47.0431,
    y1: 189.109,
    x2: 101.079,
    y2: 124.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_7062_8778",
    x1: 75.8896,
    y1: 150.088,
    x2: 95.7324,
    y2: 150.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_7062_8778",
    x1: 57.7032,
    y1: 149.927,
    x2: 77.8975,
    y2: 149.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_7062_8778",
    x1: 39.123,
    y1: 149.765,
    x2: 59.6797,
    y2: 149.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_7062_8778",
    x1: 80.6465,
    y1: 159.521,
    x2: 100.499,
    y2: 159.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_7062_8778",
    x1: 62.4668,
    y1: 159.462,
    x2: 82.6714,
    y2: 159.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_7062_8778",
    x1: 43.8945,
    y1: 159.401,
    x2: 64.4623,
    y2: 159.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_7062_8778",
    x1: 85.4248,
    y1: 169.035,
    x2: 105.286,
    y2: 169.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_7062_8778",
    x1: 67.2539,
    y1: 169.077,
    x2: 87.4687,
    y2: 169.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_7062_8778",
    x1: 48.6885,
    y1: 169.122,
    x2: 69.4762,
    y2: 169.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_7062_8778",
    x1: 97.4501,
    y1: 189.306,
    x2: 96.2715,
    y2: 197.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_7062_8778",
    x1: 96.6187,
    y1: 198.883,
    x2: 95.2588,
    y2: 207.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_7062_8778",
    x1: 107.751,
    y1: 196.872,
    x2: 54.0636,
    y2: 200.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_7062_8778",
    x1: 67.8398,
    y1: 181.902,
    x2: 113.263,
    y2: 208.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_7062_8778",
    x1: 98.6475,
    y1: 190.363,
    x2: 114.537,
    y2: 190.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_7062_8778",
    x1: 84.084,
    y1: 190.236,
    x2: 100.255,
    y2: 190.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_7062_8778",
    x1: 69.2051,
    y1: 190.104,
    x2: 85.6666,
    y2: 190.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_7062_8778",
    x1: 102.456,
    y1: 197.917,
    x2: 118.353,
    y2: 197.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_7062_8778",
    x1: 87.8984,
    y1: 197.871,
    x2: 104.078,
    y2: 197.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_7062_8778",
    x1: 73.0263,
    y1: 197.822,
    x2: 89.4968,
    y2: 197.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_7062_8778",
    x1: 106.282,
    y1: 205.536,
    x2: 122.187,
    y2: 205.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_7062_8778",
    x1: 91.7314,
    y1: 205.57,
    x2: 107.919,
    y2: 205.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_7062_8778",
    x1: 76.8652,
    y1: 205.605,
    x2: 93.5117,
    y2: 205.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_7062_8778",
    x1: 41.6863,
    y1: 208.861,
    x2: 29.8012,
    y2: 211.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_7062_8778",
    x1: 43.7749,
    y1: 218.438,
    x2: 29.6535,
    y2: 221.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_7062_8778",
    x1: 42.2729,
    y1: 188.411,
    x2: 76.544,
    y2: 125.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#09005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A0F91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_7062_8778",
    x1: 17.7916,
    y1: 208.125,
    x2: 35.3804,
    y2: 196.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_7062_8778",
    x1: 42.8457,
    y1: 185.174,
    x2: 61.4441,
    y2: 185.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_7062_8778",
    x1: 25.7998,
    y1: 185.025,
    x2: 44.7277,
    y2: 185.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_7062_8778",
    x1: 8.38475,
    y1: 184.872,
    x2: 27.6522,
    y2: 184.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_7062_8778",
    x1: 47.3037,
    y1: 194.016,
    x2: 65.9109,
    y2: 194.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_7062_8778",
    x1: 30.2646,
    y1: 193.961,
    x2: 49.2022,
    y2: 193.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_7062_8778",
    x1: 12.8564,
    y1: 193.905,
    x2: 32.1344,
    y2: 193.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_7062_8778",
    x1: 51.7822,
    y1: 202.934,
    x2: 70.3982,
    y2: 202.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_7062_8778",
    x1: 34.751,
    y1: 202.974,
    x2: 53.6981,
    y2: 202.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_7062_8778",
    x1: 17.3496,
    y1: 203.015,
    x2: 36.8337,
    y2: 203.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F52FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4042E2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCarousel03);
export default __webpack_public_path__ + "static/media/login-carousel-03.4027cd0084bb047ba770dd5ea64f32fd.svg";
export { ForwardRef as ReactComponent };